import { render, staticRenderFns } from "./Excel.vue?vue&type=template&id=1c3e904e&scoped=true"
import script from "./Excel.vue?vue&type=script&lang=ts"
export * from "./Excel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3e904e",
  null
  
)

export default component.exports